export const FORMAL_NAMES = {
  ABBR: "ABBREVIATION",
  ADDR: "ADDRESS",
  ADR1: "ADDRESS1",
  ADR2: "ADDRESS2",
  ADOP: "ADOPTION",
  AFN: "AFN",
  AGE: "AGE",
  AGNC: "AGENCY",
  ALIA: "ALIAS",
  ANCE: "ANCESTORS",
  ANCI: "ANCES_INTEREST",
  ANUL: "ANNULMENT",
  ASSO: "ASSOCIATES",
  AUTH: "AUTHOR",
  BAPL: "BAPTISM-LDS",
  BAPM: "BAPTISM",
  BARM: "BAR_MITZVAH",
  BASM: "BAS_MITZVAH",
  BIRT: "BIRTH",
  BLES: "BLESSING",
  BURI: "BURIAL",
  CALN: "CALL_NUMBER",
  CAST: "CASTE",
  CAUS: "CAUSE",
  CENS: "CENSUS",
  CHAN: "CHANGE",
  CHAR: "CHARACTER",
  CHIL: "CHILD",
  CHR: "CHRISTENING",
  CHRA: "ADULT_CHRISTENING",
  CITY: "CITY",
  CONC: "CONCATENATION",
  CONF: "CONFIRMATION",
  CONL: "CONFIRMATION_LDS",
  CONT: "CONTINUED",
  COPR: "COPYRIGHT",
  CORP: "CORPORATE",
  CREM: "CREMATION",
  CTRY: "COUNTRY",
  DATA: "DATA",
  DATE: "DATE",
  DEAT: "DEATH",
  DESC: "DESCENDANTS",
  DESI: "DESCENDANT_INT",
  DEST: "DESTINATION",
  DIV: "DIVORCE",
  DIVF: "DIVORCE_FILED",
  DSCR: "PHY_DESCRIPTION",
  EDUC: "EDUCATION",
  EMAI: "EMAIL",
  EMIG: "EMIGRATION",
  ENDL: "ENDOWMENT",
  ENGA: "ENGAGEMENT",
  EVEN: "EVENT",
  FACT: "FACT",
  FAM: "FAMILY",
  FAMC: "FAMILY_CHILD",
  FAMF: "FAMILY_FILE",
  FAMS: "FAMILY_SPOUSE",
  FAX: "FACIMILIE",
  FCOM: "FIRST_COMMUNICATION",
  FILE: "FILE",
  FORM: "FORMAT",
  FONE: "PHONETIC",
  GEDC: "GEDCOM",
  GIVN: "GIVEN_NAME",
  GRAD: "GRADUATION",
  HEAD: "HEADER",
  HUSB: "HUSBAND",
  IDNO: "IDENT_NUMVER",
  IMMI: "IMMIGRATION",
  INDI: "INDIVIDUAL",
  LANG: "LANGUAGE",
  LATI: "LATITUDE",
  LONG: "LONGITUDE",
  MAP: "MAP",
  MARB: "MARRIAGE_BANN",
  MARC: "MARRIAGE_CONTRACT",
  MARL: "MARRIAGE_LICENSE",
  MARR: "MARRIAGE",
  MARS: "MARRIAGE_SETTLEMENT",
  MEDI: "MEDIA",
  NAME: "NAME",
  NATI: "NATIONALITY",
  NATU: "NATURALIZATION",
  NCHI: "CHILDREN_COUNT",
  NICK: "NICKNAME",
  NMR: "MARRIAGE_COUNT",
  NOTE: "NOTE",
  NPFX: "NAME_PREFIX",
  NSFX: "NAME_SUFFIX",
  OBJE: "OBJECT",
  OCCU: "OCCUPATION",
  ORDI: "ORDINANCE",
  ORDN: "ORDINATION",
  PAGE: "PAGE",
  PEDI: "PEDIGREE",
  PHON: "PHONE",
  PLAC: "PLACE",
  POST: "POSTAL_CODE",
  PROB: "PROBATE",
  PROP: "PROPERTY",
  PUBL: "PUBLICATION",
  QUAY: "QUALITY_OF_DATA",
  REFN: "REFERENCE",
  RELA: "RELATIONSHIP",
  RELI: "RELIGION",
  REPO: "REPOSITORY",
  RESI: "RESIDENCE",
  RESN: "RESTRICTION",
  RETI: "RETIREMENT",
  RFN: "REC_FILE_NUMBER",
  RIN: "REC_ID_NUMBER",
  ROLE: "ROLE",
  ROMN: "ROMANIZED",
  SEX: "SEX",
  SLGC: "SEALING_CHILD",
  SLGS: "SEALING_SPOUCE",
  SOUR: "SOURCE",
  SPFX: "SURN_PREFIX",
  SSN: "SURN_PREFIX",
  STAE: "STATE",
  STAT: "STATUS",
  SUBM: "SUBMITTER",
  SUBN: "SUBMISSION",
  SURN: "SURNAME",
  TEMP: "TEMPLE",
  TEXT: "TEXT",
  TIME: "TIME",
  TITL: "TITLE",
  TRLR: "TRAILER",
  TYPE: "TYPE",
  VERS: "VERSION",
  WIFE: "WIFE",
  WILL: "WILL",
  WWW: "WEB",
} as const;
